import studiesData from '../data/studies.json';

function unescapeEntities(str) {
  if (!str) return '';
  const txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
}

export function renderStudiesCatalog(container) {
  if (!container) return;

  let activeFilter = 'All';
  let searchQuery = '';

  function render() {
    const filtered = studiesData.filter(study => {
      const matchesSearch = searchQuery === '' || 
        study.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        study.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
        study.tags.some(t => t.toLowerCase().includes(searchQuery.toLowerCase()));

      if (!matchesSearch) return false;

      if (activeFilter === 'All') return true;
      if (activeFilter === 'Topical') return study.categories.includes('Topical');
      if (activeFilter === 'Book') return study.categories.includes('Book');
      if (activeFilter === 'Men') return study.tags.includes('Men') || study.tags.includes('Husbands') || study.tags.includes('Fathers');
      return true;
    });

    container.innerHTML = `
      <div class="studies-page">
        <!-- Studies Header Banner -->
        <header class="studies-hero">
          <div class="wt-container text-center">
            <div class="studies-brand-pill">
              <i class="fa-solid fa-book-open-reader"></i>
              <span>StudyTogether</span>
            </div>
            <h1 class="studies-title">Bible Studies & Guides</h1>
            <p class="studies-subtitle">
              In-depth, accessible Bible studies and devotionals created for men, families, and disciple makers. 
              Download printable PDFs, Word documents, or open live in Google Docs.
            </p>

            <!-- Search & Filter Controls -->
            <div class="studies-controls">
              <div class="studies-search-box">
                <i class="fa-solid fa-magnifying-glass search-icon"></i>
                <input 
                  type="text" 
                  id="study-search-input" 
                  placeholder="Search studies (e.g., Romans, Leadership, Finances, Revelation)..." 
                  value="${searchQuery}" 
                />
                ${searchQuery ? `<button id="study-clear-search" class="clear-btn">&times;</button>` : ''}
              </div>

              <div class="studies-filter-chips">
                <button class="filter-chip ${activeFilter === 'All' ? 'active' : ''}" data-filter="All">All Studies (${studiesData.length})</button>
                <button class="filter-chip ${activeFilter === 'Topical' ? 'active' : ''}" data-filter="Topical">Topical Studies</button>
                <button class="filter-chip ${activeFilter === 'Book' ? 'active' : ''}" data-filter="Book">Book of the Bible</button>
                <button class="filter-chip ${activeFilter === 'Men' ? 'active' : ''}" data-filter="Men">For Men</button>
              </div>
            </div>
          </div>
        </header>

        <!-- Studies Catalog Grid -->
        <main class="wt-container studies-grid-container">
          ${filtered.length === 0 ? `
            <div class="studies-empty text-center">
              <i class="fa-solid fa-magnifying-glass-chart empty-icon"></i>
              <h3>No studies found</h3>
              <p>Try adjusting your search query or selecting a different filter.</p>
              <button class="btn-primary" id="study-reset-btn">Reset Filters</button>
            </div>
          ` : `
            <div class="studies-grid">
              ${filtered.map(study => `
                <article class="study-card">
                  <div class="study-card-image-wrap">
                    <img 
                      src="${study.featured_image || '/assets/martin-pechy-u-2g_UCBP4E-unsplash-1024x683.jpg'}" 
                      alt="${study.title}" 
                      loading="lazy" 
                      class="study-card-img"
                    />
                    <div class="study-card-category-badge">
                      ${study.categories.join(' • ') || 'Bible Study'}
                    </div>
                  </div>

                  <div class="study-card-body">
                    <div class="study-tag-pills">
                      ${study.tags.slice(0, 3).map(tag => `<span class="study-tag-pill">${tag}</span>`).join('')}
                    </div>

                    <h2 class="study-card-title">
                      <a href="#study/${study.slug}">${study.title}</a>
                    </h2>

                    <p class="study-card-excerpt">
                      ${unescapeEntities(study.description).slice(0, 160)}...
                    </p>

                    <div class="study-card-actions">
                      <a href="#study/${study.slug}" class="study-btn-details">
                        <i class="fa-regular fa-eye"></i> Details
                      </a>

                      ${study.pdf_url ? `
                        <a href="${study.pdf_url}" download="${study.pdf_filename || 'study.pdf'}" class="study-btn-dl pdf-btn" title="Download PDF format">
                          <i class="fa-solid fa-file-pdf"></i> PDF
                        </a>
                      ` : ''}

                      ${study.docx_url ? `
                        <a href="${study.docx_url}" download="${study.docx_filename || 'study.docx'}" class="study-btn-dl doc-btn" title="Download Word DOCX format">
                          <i class="fa-solid fa-file-word"></i> DOC
                        </a>
                      ` : ''}

                      ${study.google_doc_url ? `
                        <a href="${study.google_doc_url}" target="_blank" rel="noopener noreferrer" class="study-btn-dl gdoc-btn" title="Open live Google Doc">
                          <i class="fa-brands fa-google-drive"></i> Doc
                        </a>
                      ` : ''}
                    </div>
                  </div>
                </article>
              `).join('')}
            </div>
          `}
        </main>
      </div>
    `;

    // Event handlers
    const searchInput = document.getElementById('study-search-input');
    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        searchQuery = e.target.value;
        render();
        const inputNow = document.getElementById('study-search-input');
        if (inputNow) {
          inputNow.focus();
          inputNow.selectionStart = inputNow.selectionEnd = searchQuery.length;
        }
      });
    }

    const clearBtn = document.getElementById('study-clear-search');
    if (clearBtn) {
      clearBtn.onclick = () => {
        searchQuery = '';
        render();
      };
    }

    const resetBtn = document.getElementById('study-reset-btn');
    if (resetBtn) {
      resetBtn.onclick = () => {
        searchQuery = '';
        activeFilter = 'All';
        render();
      };
    }

    const filterBtns = container.querySelectorAll('.filter-chip');
    filterBtns.forEach(btn => {
      btn.onclick = () => {
        activeFilter = btn.dataset.filter;
        render();
      };
    });
  }

  render();
}
